<br>
<div>
    <div class="textBlock">
        <div>
            <p class="h2 text-center">Halte 1</p>
            <hr>
        </div>
        <div>
            <div class="text-center">
            <p class="h4 text-center">
                Historie
            </p>
            <hr>
                <p class="text-center d-block margin">
                    Dit was vroeger het bos van ‘het zwarte manneke’. Een legendarische griezel in een lange zwarte jas, waar de kleinste leden van de chiro in de jaren ’70 van de vorige eeuw heel bang van waren. Of werden gemaakt voor de leiding. Want hij is nooit gevonden. En misschien heeft hij dus ook wel nooit bestaan. Maar het leverde wel zalige bosspelletjes op.             
                </p>
                <img src="http://2.bp.blogspot.com/-vKeGz0SB3G4/UUCMpkeoIiI/AAAAAAAAAEE/b-3icjKqAaI/s1600/The+Man+In+The+Long+Black+Coat.jpg" alt="ZwarteManneke.png">
            </div>
            <hr class="afterImage">
            <p class="h4 text-center">
                Navigatie
            </p>
            <hr>
            <p class="text-center d-block margin">
                Steek hier het bos door. Wandel steeds rechtdoor. Je moet wel aan den ‘kruispunt’ over een omgehakte boom kruipen. Daar voorbij wandel je naast een beekje. Aan het einde van het weggetje kom je opnieuw aan een groene poort. Wandel het bos uit en ga naar rechts.             
            </p>
        </div>
        
    </div>
    <div class="text-center buttonMargin">
        <button type="button" class="btn btn-primary" [routerLink]="'/halte2'">Volgende stop</button>
    </div>
</div>